// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useChoiceGroupApi } from '../../Hooks/useChoiceGroupApi';
import { useOrderManagementApi } from '../../Hooks/useOrderManagementApi';


export const UseCreateChoiceGroup = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createChoiceGroup } = useChoiceGroupApi();
  return useMutation({
    mutationKey: ['CreateChoiceGroup'],
    mutationFn: (data: any) => createChoiceGroup(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'ChoiceGroup created successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getChoiceGroup'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create ChoiceGroup',
        'error'
      );
    },
  });
};

export const usePatchChoiceGroup = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useChoiceGroupApi();

  return useMutation({
    mutationKey: ['PatchChoiceGroup'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === 'unblocked' ? 'unblocked' : 'blocked';
      showMessage(`Choice Group ${action} successfully`, 'success');
      queryClient.invalidateQueries({
        queryKey: ['getChoiceGroup'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
        'Failed to block the Choice Group',
        'error'
      );
    },
  });
};

export const useDeleteChoiceGroup = () => {
  const queryClient = useQueryClient();
  const { deleteChoiceGroup } = useChoiceGroupApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteChoiceGroup'],
    mutationFn: (ids: string[]) => {
      return deleteChoiceGroup(ids);
    },
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'ChoiceGroup deleted successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getChoiceGroup'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to deleted ChoiceGroup',
        'error'
      );
    },
  });
};

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const orderManagementQuery = (queryParams: Params) => {
 const { getAllOrderManagement } = useOrderManagementApi();

  const { data, isLoading: isFetching, refetch, isRefetching } = useQuery({
    queryKey: ['getallorderdetails', queryParams],
    queryFn: () => getAllOrderManagement(queryParams),
    enabled: Boolean(Object.keys(queryParams).length), // disable if params empty
    retry: false,
    refetchInterval: 20000, // 20 seconds polling interval
    refetchIntervalInBackground: true, // Continue polling even when tab is not active
  });

  return {
    data,
    isLoading: isFetching || isRefetching,
    refetch,
  };
};

export const useEditChoiceGroup = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editChoiceGroup } = useChoiceGroupApi();

  return useMutation({
    mutationKey: ['EditSubAdmin'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editChoiceGroup(id, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'ChoiceGroup Updated successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getChoiceGroup'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
        'Failed to update the ChoiceGroup',
        'error'
      );
    },
  });
};
